import styled from 'styled-components';
import ArrowBack from '@mui/icons-material/ArrowBack';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  padding: 1rem 0.6rem 2rem;
  width: 100%;
  min-height: 380px;
  max-width: 300px;
  border-radius: 20px;
  background: ${({ theme }) => theme.pantone657C};
  box-shadow: 0px 25px 50px -12px #00000040;
  box-shadow: 0px 4px 4px 0px #00000040;
  text-align: center;
`;

export const AreaText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.2rem;
`;
export const Title = styled.h2`
  font-size: 1.6rem;
`;
export const Description = styled.p`
  font-size: 0.9rem;
`;

export const LinkArea = styled.div`
  margin-top: auto;
  a {
    &:hover {
      text-decoration: underline;
    }
  }
`;
export const LinkText = styled.span`
  color: ${({ theme }) => theme.white};
`;
export const IconArrowRight = styled(ArrowBack)`
  margin-left: 2rem;
  transform: rotate(180deg);
  color: ${({ theme }) => theme.white};
`;

